export default __webpack_public_path__ + "static/media/image-home.ca9ead9d.webp";